export default class ContextMissingError extends Error {
    constructor() {
        super(`The function was rendered outside of the needed context.`);
        this.name = "ContextMissingError";
    }
}